import Icon from '../components/Icon.vue'

Icon.register({
  'share-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 320C329.4 320 308.6 327.8 292.2 340.9L189.7 276.8A96.6-96.6 0 0 1 189.7 235.2L292.2 171.1C308.6 184.2 329.4 192 352 192 405 192 448 149 448 96S405 0 352 0 256 43 256 96C256 103.2 256.8 110.1 258.3 116.8L155.8 180.9C139.4 167.8 118.6 160 96 160 43 160 0 203 0 256S43 352 96 352C118.6 352 139.4 344.2 155.8 331.1L258.3 395.2A96.3-96.3 0 0 1 256 416C256 469 299 512 352 512S448 469 448 416 405 320 352 320z'
      }
    ]
  }
})
